<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.42">
      <template #main>
        <TableMain name="one table" ref="ConsultQuoteExecuteTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" date_picker_label="创建时间"
          :query_button_label="query_lable" :isBusy="isBusy" :show_toolbar_state="false" :show_email="true"
          :email_label="'send_email'" :hb_table_class="'hb_table_cqe_class1'" @email_invoke="SendEmail"
          @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]" :only_text="$t('common.show_all')"
          @only_methods="only_methods" :table_height_adjust="-6" @current_changed="current_changed" tableref="f5543af9c995406fb69cd212674e179d">
          <template #query>
            <el-input clearable size="small" style="width: 200px" placeholder="请输入询价单编号"
              v-model="ConsultQuoteNum"></el-input>
          </template>
          <template #toolbar>
            <el-popover placement="right" title="提示" width="260" trigger="hover" style="border-color: red;">
              <p>1、默认显示未处理或未发邮件的询价单；</p>
              <p>2、红色表示未处理；</p>
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
              <template #content>
                sdfsdf
              </template>
            </el-popover>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="ConsultQuoteExecuteTable2" :fields="detail_fields" :show_query_container="false"
          :title="table_title.title2" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy2" :loading_width="90"
          :check_state="true" @state_change="detail_state_change" :hb_table_class="'hb_table_cqexue_class1'"
          :show_toolbar_state="false" tableref="b50d5a0712f8441ab95f36b6b4ecb7a4">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="ConsultQuoteExecuteTable3" :fields="consult_vend_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_toolbar="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :loading_width="90" :show_email="true" :email_label="'send_email'" :hb_table_class="'hb_table_cqexue_class2'"
          @email_invoke="SendEmailAlone" @state_change="detail_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
          :show_toolbar_state="false" tableref="10f8c640681e4052bcf7f202529c49d0">
          <template #toolbar>
            <el-select filterable clearable multiple collapse-tags reserve-keyword :placeholder="$t('common.provider')"
              :filter-method="remoteVenderMethod" class="ml-2" v-model="venders" style="width: 25rem"
              @clear="remoteVenderMethod" @remove-tag="remoteVenderMethod(venders)" @focus="remoteVenderMethod('')">
              <el-option v-for="(item, index) in vender_options" :key="index"
                :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum">
              </el-option>
            </el-select>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="AppendVendIntoDetail"><i
                class="fa fa-plus"></i></el-button>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import QueryButton from "../components/base/QueryButton"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton,
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_quote",
        title2: "table_consult_quote_detail",
        title3: "table_consult_quote_vend",
      },
      cqe_modal_title: "",
      fields: _.cloneDeep(ConsultQuoteConttroller.fields.default),
      detail_fields: _.cloneDeep(ConsultQuoteConttroller.fields.detail),
      // detail_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_vend_fields),
      consult_vend_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_vend_fields),
      qt_modal_title: "",
      ConsultQuoteNum: "",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      InventListHis: [],
      vender_options: [],
      venders: [],
      query_date: [],
      filter_invent_name_key: "",
      filter_quote_task_key: "",
      isAll: false,
      hisConsultOrderData: []
    }
  },
  created() {
    this.fields = _.filter(this.fields, (t) => {
      return t.key != "is_valid"
    })
    let unIncludeFields = ["DistributionRatio", "is_approved", "approved_by_username", "Accessory", "ConsultQuoteNum", "is_send_email"]
    this.detail_fields = _.filter(this.detail_fields, (t) => {
      delete t.editable
      return !_.includes(unIncludeFields, t.key)
    })

    this.consult_vend_fields = _.filter(this.consult_vend_fields, (t) => {
      if (t.key != "Description") delete t.editable
      return t.key != "DistributionRatio" && t.key != "DistributionDes" && t.key != "is_approved" && t.key != "approved_by_username"
    })

  },
  mounted() { },
  methods: {
    remoteVenderMethod(query) {
      if (_.isArray(query)) {
        if (query.length == 0) {
          query = ""
        } else {
          return
        }
      }

      let data = []
      let mainCurrent = this.$refs.ConsultQuoteExecuteTable1.GetCurrentItem()
      console.log(mainCurrent)
      let vender_list = _.cloneDeep(_.filter(this.$store.state.biz_data.baseData.AllVender, (t) => {
        if (t.dataAreaId == mainCurrent.dataAreaIds && t.Blocked == '否') return t
      }))
      console.log(vender_list)
      if (query && query !== "") {
        let _filter_list = vender_list.filter((item) => {
          return (
            item.AccountNum.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            item.SEI_Name.indexOf(query) > -1
          )
        })
        data = _.cloneDeep(_filter_list).splice(0, 100)
      } else
        data = _.cloneDeep(vender_list).splice(0, 300)

      this.vender_options = _.uniqBy(data, "AccountNum")
    },
    only_methods(v) {
      this.isAll = v
      let dt = this.hisConsultOrderData
      if (!this.$refs.ConsultQuoteExecuteTable1.only_value)
        dt = _.filter(dt, (t) => {
          t._error = !t.fcCheckCQHandleIsOk
          if (!this.isAll)
            return !t.fcCheckCQHandleIsOk || !t.is_send_email
          return t
        })
      this.$refs.ConsultQuoteExecuteTable1.SetData(dt)
    },
    async on_query(set_data, _date, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = { is_deleted: { "=": 0 } }
      if (this.ConsultQuoteNum != "") {
        p.ConsultQuoteNum = { like: "%" + this.ConsultQuoteNum + "%" }
      }
      else if (_date && _date.length > 0) {
        this.query_date = _date
        let _fromDate = this.$date.format(_date[0], "yyyy-MM-dd")
        let _toDate = this.$date.format(_date[1], "yyyy-MM-dd")
        p["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }

      let _result = await ConsultQuoteConttroller.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_.orderBy(_.cloneDeep(_result[0]), ["id"], ["desc"]), { is_valid: true })
        dt.forEach((t) => {
          let _json = { quotation_task_num: "", cust_name: "", dataAreaIds: "" }
          if (t.fcGetConsultQuoteDetailInfo && t.fcGetConsultQuoteDetailInfo != "")
            _json = JSON.parse(t.fcGetConsultQuoteDetailInfo.replace(/\s+/g, ""))
          t.QuotationTaskNums = _json.quotation_task_num
          t.CustNames = _json.cust_name
          t.dataAreaIds = _json.dataAreaIds
        })
        this.hisConsultOrderData = _.cloneDeep(dt)
        if (!this.$refs.ConsultQuoteExecuteTable1.only_value)
          dt = _.filter(dt, (t) => {
            t._error = !t.fcCheckCQHandleIsOk
            if (!this.isAll)
              return !t.fcCheckCQHandleIsOk || !t.is_send_email
            return t
          })
        set_data(dt)
      }
      this.isBusy = false
    },
    async current_changed(old, current) {
      this.$refs.ConsultQuoteExecuteTable2.SetData([])
      this.$refs.ConsultQuoteExecuteTable3.SetData([])
      if (current) {
        this.isBusy2 = true
        await this.Detail_Query(current)
        // this.$refs.ConsultQuoteExecuteTable2.SetData(_.cloneDeep(this.$store.state.biz_data.baseData.Vender));
        this.isBusy2 = false
        this.isBusy3 = true
        await this.GetVendData(current)
        this.isBusy3 = false
      }
    },
    ///查询报价明细
    async Detail_Query(QT) {
      let p = { ConsultQuoteId: QT.id }
      let _result = await ConsultQuoteConttroller.methods.getDetailDataSql(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["LineNum"], ["asc"])
        this.$refs.ConsultQuoteExecuteTable2.SetData(dt)
      }
    },
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      let real_del_dt = _.filter(data.selected_items, (t) => { return t.id !== "" })
      if (real_del_dt && real_del_dt.length > 0) {
        let p = {}
        if (data.state == "deleted")
          p.delete = real_del_dt

        let rt = await ConsultQuoteConttroller.methods.saveDataVend(p)
        if (rt) {
          this.$refs.ConsultQuoteExecuteTable3.RemoveItems(real_del_dt)
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          cb(true)
        }
        else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      }
      let remove_dt = _.filter(data.selected_items, (t) => { return t.id === "" })
      if (remove_dt && remove_dt.length > 0)
        this.$refs.ConsultQuoteExecuteTable3.RemoveItems(remove_dt)

      if (this.$refs.ConsultQuoteExecuteTable3.length == 0) {
        let mainCurrent = this.$refs.ConsultQuoteExecuteTable1.GetCurrentItem()
        mainCurrent.fcCheckCQHandleIsOk = false
        mainCurrent._error = true
      }
    },
    AppendVendIntoDetail() {
      if (this.venders.length == 0) return
      _.each(this.venders, (accounteNum) => {
        let m = _.find(_.cloneDeep(this.$store.state.biz_data.baseData.Vender), { AccountNum: accounteNum })
        if (m) {
          m.id = ""
          if (!_.some(this.$refs.ConsultQuoteExecuteTable3.my_data, { AccountNum: m.AccountNum }))
            this.$refs.ConsultQuoteExecuteTable3.AppendItems(m)
        }
      })

    },

    async GetVendData(current, isNeedReturn = false) {
      let p = { ConsultQuoteId: { "=": current.id }, is_deleted: { "=": 0 } }
      let _result = await ConsultQuoteConttroller.methods.getDataVend(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let detail_venders = []
        _.each(_result[0], (t) => {
          let m = _.find(_.cloneDeep(this.$store.state.biz_data.baseData.Vender), { AccountNum: t.AccountNum })
          m.id = t.id
          m.Description = t.Description
          m.DistributionRatio = t.DistributionRatio
          m.is_send_email = t.is_send_email
          if (current.is_send_email) m.is_send_email = true
          if (m) detail_venders.push(m)
        })
        if (isNeedReturn)
          return detail_venders
        else
          this.$refs.ConsultQuoteExecuteTable3.SetData(_.orderBy(detail_venders, ["id"], ["asc"]))
      }
    },
    ///保存明细
    async Detail_SaveData(cb) {
      //数据验证
      let detail_data = this.$refs.ConsultQuoteExecuteTable3.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let mainCurrent = this.$refs.ConsultQuoteExecuteTable1.GetCurrentItem()
      let p = { add: [], edit: [] }
      _.each(detail_data, (t) => {
        let m = {
          id: t.id,
          ConsultQuoteId: mainCurrent.id,
          AccountNum: t.AccountNum,
          Description: t.Description,
          DistributionRatio: t.DistributionRatio
        }
        if (t.id == "") {
          delete m.id
          p.add.push(m)
        }
        else {
          p.edit.push(m)
        }
      })

      let rt = await ConsultQuoteConttroller.methods.saveDataVend(p)
      if (rt) {
        let p1 = { edit: [] }
        p1.edit.push({ id: mainCurrent.id, is_send_email: false })
        let rt = await ConsultQuoteConttroller.methods.saveData(p1)
        if (!_.isNull(rt)) mainCurrent.is_send_email = false
        await this.GetVendData(mainCurrent)
        mainCurrent.fcCheckCQHandleIsOk = true
        mainCurrent._error = false
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
      cb(false)
    },
    ///查询报价明细
    async GetConsultDetailData(QTId) {
      let p = { is_deleted: { "=": 0 } }
      p.ConsultQuoteId = { "=": QTId }
      let _result = await ConsultQuoteConttroller.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        return _.orderBy(_result[0], ["LineNum"], ["asc"])
      }
      return []
    },
    ///发送邮件
    async SendEmail(data) {
      let selected_items = data.selected_items
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      //检查是否重复发送
      let msg = ""
      _.each(selected_items, (t) => {
        if (msg == "" && t.is_send_email)
          msg = "邮件已发送，请勿重复发送！"
        else if (msg == "" && !t.fcCheckCQHandleIsOk)
          msg = "单据未处理，不能发送邮件！"
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        return
      }
      let dt = [], dt_detail = []
      for (var i in selected_items) {
        let t = selected_items[i]
        let rt = _.map(await this.GetVendData(t, true), (m) => {
          m.ConsultQuoteId = t.id
          m.ConsultQuoteNum = t.ConsultQuoteNum
          return m
        })
        dt = _.union(dt, rt)
        //明细数据
        let rt_detail = await this.GetConsultDetailData(t.id)
        dt_detail = _.union(dt_detail, rt_detail)
      }

      if (dt.length == 0) {
        this.msgToasts("暂无邮件明细，不能发送邮件！", "info")
        return
      }

      let is_ok = await this.msgModal(this.$t("notify.is_send_email"))
      if (!is_ok) {
        return
      }

      let emailNotifyData = []
      let groupByAccountNumList = _.groupBy(dt, "AccountNum")
      for (var k in groupByAccountNumList) {
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: k })
        //整理邮件接收人
        let sendTo = {}
        if (!vm || !vm.EmailContact || vm.EmailContact == "") {
          continue
        }
        vm.EmailContact = vm.EmailContact.replace(/；/g, ";")
        let users = vm.EmailContact.split(";")
        for (var u in users) {
          let ncode = _.trim(users[u])
          if (ncode != "")
            sendTo[ncode] = ncode
        }
        //整理邮件内容
        let content = "", e_data = { linkUrl: "", data: [] }, _item = { num: "", items: [] }
        e_data.linkUrl = window.location.protocol + "//" + window.location.host + "/pages/Guest?k=" + vm.idx
        let templates = this.$store.state.biz_data.templateData.templates

        let gb_consultnum_dt = _.groupBy(groupByAccountNumList[k], "ConsultQuoteNum")
        for (var itk in gb_consultnum_dt) {
          _item.num = itk
          _item.items = _.filter(dt_detail, { ConsultQuoteNum: itk })
          e_data.data.push(_item)
        }
        if (templates) {
          let m = _.find(templates, { notify_type: "vend_pre_quote_application" })
          if (m) {
            var fn = template.compile(m.content)
            content = fn(e_data)
          }
        }
        let _notify_p = {
          category: "consult_notify", //询价通知
          idx: "",
          itemId: 0,
          notify_type: "consult_notify", //如：so_approve_pass
          subject: "来自斯道拉恩索的采购询价申请",
          content: content,
          SendTo: sendTo
        }

        emailNotifyData.push(_notify_p)
      }
      if (emailNotifyData.length > 0) {
        let p = { edit: [] }
        p.edit = _.map(selected_items, (t) => {
          t.is_send_email = true
          t.send_email_date = this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
          return { id: t.id, is_send_email: t.is_send_email, send_email_date: t.send_email_date }
        })
        let rt = await ConsultQuoteConttroller.methods.saveData(p)
        if (_.isNull(rt)) {
          _.each(selected_items, (t) => {
            t.is_send_email = true
          })
          return
        }
        let _rsult = await commonController.methods.sendOrCancelNotify(data.code, emailNotifyData)
        if (!_.isNull(_rsult)) {
          this.msgToasts(this.$t("notify.email_send_success"), "success")
        }

      }
    },
    async SendEmailAlone(data) {
      let selected_items = _.cloneDeep(data.selected_items)
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      //检查是否重复发送
      let msg = ""
      _.each(selected_items, (t) => {
        if (msg == "" && t.id === "")
          msg = "单据未保存，不能发送邮件！"
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        return
      }
      let dt = [], dt_detail = []
      let mainCurrent = this.$refs.ConsultQuoteExecuteTable1.GetCurrentItem()
      //明细数据
      let rt_detail = await this.GetConsultDetailData(mainCurrent.id)
      dt_detail = _.union(dt_detail, rt_detail)
      for (var i in selected_items) {
        let t = selected_items[i]
        t.ConsultQuoteId = mainCurrent.id
        t.ConsultQuoteNum = mainCurrent.ConsultQuoteNum
        dt.push(t)
      }
      let sended_dt = _.filter(this.$refs.ConsultQuoteExecuteTable3.my_data, { is_send_email: true })
      if (dt.length == 0) return
      let is_ok = await this.msgModal(this.$t("notify.is_send_email"))
      if (!is_ok) {
        return
      }
      else if (sended_dt.length > 0) {
        let ask = await this.$confirm("选择项中存在已发邮件数据，是否继续？").then(t => { return true }).catch(t => { return false })
        if (!ask) return
      }

      let emailNotifyData = []
      let groupByAccountNumList = _.groupBy(dt, "AccountNum")
      for (var k in groupByAccountNumList) {
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: k })
        //整理邮件接收人
        let sendTo = {}
        if (!vm || !vm.EmailContact || vm.EmailContact == "") {
          continue
        }
        vm.EmailContact = vm.EmailContact.replace(/；/g, ";")
        let users = vm.EmailContact.split(";")
        for (var u in users) {
          let ncode = _.trim(users[u])
          if (ncode != "")
            sendTo[ncode] = ncode
        }
        //整理邮件内容
        let content = "", e_data = { linkUrl: "", data: [] }, _item = { num: "", items: [] }
        e_data.linkUrl = window.location.protocol + "//" + window.location.host + "/pages/Guest?k=" + vm.idx
        let templates = this.$store.state.biz_data.templateData.templates

        let gb_consultnum_dt = _.groupBy(groupByAccountNumList[k], "ConsultQuoteNum")
        for (var itk in gb_consultnum_dt) {
          _item.num = itk
          _item.items = _.filter(dt_detail, { ConsultQuoteNum: itk })
          e_data.data.push(_item)
        }
        if (templates) {
          let m = _.find(templates, { notify_type: "vend_pre_quote_application" })
          if (m) {
            var fn = template.compile(m.content)
            content = fn(e_data)
          }
        }
        let _notify_p = {
          category: "consult_notify", //询价通知
          idx: "",
          itemId: 0,
          notify_type: "consult_notify", //如：so_approve_pass
          subject: "来自斯道拉恩索的采购询价申请",
          content: content,
          SendTo: sendTo
        }

        emailNotifyData.push(_notify_p)
      }
      console.log(emailNotifyData)

      if (emailNotifyData.length > 0) {
        let _rsult = await commonController.methods.sendOrCancelNotify(data.code, emailNotifyData)
        if (!_.isNull(_rsult)) {
          let p = { add: [], edit: [] }
          p.edit = _.map(data.selected_items, (t) => { t.is_send_email = true; return { id: t.id, is_send_email: true } })
          let rt = await ConsultQuoteConttroller.methods.saveDataVend(p)
          let has_send_email_dt = _.filter(this.$refs.ConsultQuoteExecuteTable3.my_data, { is_send_email: true })
          if (rt && has_send_email_dt.length == this.$refs.ConsultQuoteExecuteTable3.my_data.length) {
            ///如果明细全部发了邮件，则主档的邮件也要变更为已发送
            let mainCurrent = this.$refs.ConsultQuoteExecuteTable1.GetCurrentItem()
            mainCurrent.is_send_email = true
            let p1 = { edit: [] }
            p1.edit.push({ id: mainCurrent.id, is_send_email: true })
            await ConsultQuoteConttroller.methods.saveData(p1)
          }
          this.msgToasts(this.$t("notify.email_send_success"), "success")
        }

      }
      else {
        this.msgToasts("请检查是否已完善供应商联系人邮件！", "info")
      }
    }
  },
}
</script>
<style>
.hb_table_cqe_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}

.hb_table_cqexue_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 180rem;
}

.hb_table_cqexue_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 70rem;
}
</style>
